import { transactions } from './history-config/HU';
import { savings } from './savings-config/HU';
import { statements } from './statements-config/HU';

export const buildingSociety = {
    transactions,
    savings,
    statements,
    overview: {
        enabled: true,
        list: {
            jointContractHoldersDisplay: false,
        },
    },
    dashboard: {
        displayContractNumber: true,
    },
};
